export const QUESTIONS = [
  "I have felt cheerful and in good spirits",
  "I have felt calm and relaxed",
  "I have felt active and vigorous",
  "I woke up feeling fresh and rested",
  "My daily life has been filled with things that interest me",
];

export const OPTIONS = [[5, "All of the time"], [4, "Most of the time"], [3, "More than half of the time"], [2, "Less than half of the time"], [1, "Some of the time"], [0, "At no time"]];

export const BAND_LOOK = {
  thriving: { emoji: "🌻", bg: "#FFF3C9", ink: "#7A5200", line: "You're in a good place. Keep doing what's working.",
    tips: ["Notice what's helping right now and write it down, so you can come back to it on harder weeks.", "Share some of that energy with someone you care about."] },
  okay: { emoji: "🌤️", bg: "#E6F3FB", ink: "#1F5A7A", line: "You're getting by, with room to feel a bit better.",
    tips: ["Pick one small thing that usually lifts you and plan it for this week.", "A daily 2-minute check-in can show you what moves your mood."] },
  low: { emoji: "🌧️", bg: "#EEE8FA", ink: "#4B3290", line: "Things have felt heavy lately. That's worth taking seriously, gently.",
    tips: ["Tell one person you trust how the last two weeks have really been.", "Consider talking to a doctor or counsellor. A score of 50 or below is a common point to get a check-up."] },
  very_low: { emoji: "🫶", bg: "#FCE8EE", ink: "#8E2B4E", line: "You've been carrying a lot. You don't have to carry it alone.",
    tips: ["Please reach out to a doctor, counsellor or someone you trust soon.", "If you ever feel unsafe, contact a crisis line below right away."] },
};
